<template>
    <div class="section">

      <!-- Parallax -->
      <div :class="[{'g-fullheight--xs': block.options.fullHeight}, 'js__parallax_' + block.blockID]" :style="sectionStyle">
          <div class="container g-text-center--xs g-padding-y-80--xs g-padding-y-125--sm">
              <div class="g-margin-b-80--xs">
                  <h2 class="g-font-size-40--xs g-font-size-50--sm g-font-size-60--md" v-html="block.options.title.text" :style="titleStyle" ref="title"></h2>
                  <h2 class="g-font-size-32--xs g-font-size-36--md" v-html="block.options.subtitle.text" :style="subtitleStyle" ref="subtitle"></h2>
              </div>
              <a class="text-uppercase s-btn s-btn--md s-btn--white-brd g-radius--50 g-padding-x-50--xs" v-for="(button, i) in block.options.buttons" :key="button.id" :href="button.href" :target="button.target" v-html="button.text" @click.stop.prevent="clickDisable()"></a>
          </div>
      </div>
      <!-- End Parallax -->

      <block-settings :block="block" :order="order" @moveBlockUp="moveBlockUp" @moveBlockDown="moveBlockDown" @deleteBlock="deleteBlock" @afterUpload="afterUpload" @afterSettingsClose="afterSettingsClose"></block-settings>

    </div>
</template>

<script>
import { BlocksMixin } from "../util/mixins";

export default {
  mixins: [BlocksMixin],
  mounted() {
    this.editables = [this.$refs.title, this.$refs.subtitle];
  },
  computed: {
    sectionStyle() {
      return {
        background: this.block.options.bg.url
          ? `url( ${this.block.options.bg.url} ) 50% 0 no-repeat fixed`
          : this.block.options.bg.color
      };
    },
    titleStyle() {
      return {
        color: this.block.options.title.color
      };
    },
    subtitleStyle() {
      return {
        color: this.block.options.subtitle.color
      };
    }
  },
  methods: {
    deleteBlock() {
      if (this.editor1) {
        this.editor1.destroy();
      }
      this.$emit("deleteBlock");
    },
    afterUpload() {},
    afterSettingsClose() {
      this.$parent.win.initParallax(
        this.block.blockID,
        this.block.options.parallax.percentage,
        this.block.options.parallax.speed
      );
    },
    afterMove() {
      this.$parent.win.initParallax(
        this.block.blockID,
        this.block.options.parallax.percentage,
        this.block.options.parallax.speed
      );
    },
    appendCustomScript() {
      this.addScriptInline(`
        $(document).ready(function() {
          initParallax(${this.block.blockID}, ${this.block.options.parallax
        .percentage}, ${this.block.options.parallax.speed});
        });
      `);
    }
  }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/blocks/BlockParallax1.vue